module.exports = __webpack_public_path__ + "img/icon-bed-blue.11aea7ff.svg";